/**
 * 24h 만료 안내 페이지 — FE-W-03 skeleton (FE-W-09 에서 본문 확장).
 */

import { useSyncExternalStore } from 'react';
import { Link } from 'react-router-dom';
import { useOnboardingStore } from '../../store/onboardingStore';
import { tOnb, getOnboardingLang, subscribeOnboardingLang } from '../../lib/onboarding-i18n';

export function OnboardingExpiredPage() {
  useSyncExternalStore(subscribeOnboardingLang, getOnboardingLang, getOnboardingLang);
  const reset = useOnboardingStore((s) => s.reset);
  return (
    <div role="alert" aria-live="assertive">
      <h2 className="onboarding-step__heading">{tOnb('onboarding.expired.heading')}</h2>
      <p className="onboarding-step__subheading">
        {tOnb('onboarding.expired.line1')}<br />
        {tOnb('onboarding.expired.line2')}
      </p>
      <div className="onboarding-step__actions">
        <Link
          to="/signup"
          className="onboarding-step__button onboarding-step__button--primary"
          style={{ textAlign: 'center', textDecoration: 'none', display: 'inline-block' }}
          onClick={() => reset()}
        >
          {tOnb('onboarding.expired.btn_restart')}
        </Link>
        <Link
          to="/login"
          className="onboarding-step__button onboarding-step__button--secondary"
          style={{ textAlign: 'center', textDecoration: 'none', display: 'inline-block' }}
        >
          {tOnb('onboarding.btn.to_login')}
        </Link>
      </div>
    </div>
  );
}
